import TokenData from 'TokenData';

/** Dedupe parallel setupAssetStorage calls (e.g. many images loading at once). */
let inFlightAssetStorageSetup: Promise<TokenData> | null = null;
let inFlightAssetStorageSetupForce: Promise<TokenData> | null = null;

export function getInFlightAssetStorageSetup(forceRetrieve: boolean): Promise<TokenData> | null {
  return forceRetrieve ? inFlightAssetStorageSetupForce : inFlightAssetStorageSetup;
}

export function setInFlightAssetStorageSetup(
  forceRetrieve: boolean,
  promise: Promise<TokenData> | null,
): void {
  if (forceRetrieve) {
    inFlightAssetStorageSetupForce = promise;
  } else {
    inFlightAssetStorageSetup = promise;
  }
}

/**
 * Designer-only env (see vite-designer.config). Not in production .env.template, so
 * webpack DefinePlugin does not replace it — reading process.env.* would throw in the browser.
 */
export function optionalReactAppEnv(name: 'REACT_APP_STORAGE_BASE_URL'): string | undefined {
  if (typeof process === 'undefined') {
    return undefined;
  }
  return process.env[name];
}

/** Extract GCS bearer token from /api/setupAssetStorage (handles staging + local shapes). */
export function getAssetStorageAccessToken(tokenData: TokenData | null | undefined): string | null {
  if (!tokenData?.token) {
    return null;
  }
  const inner = tokenData.token as TokenData['token'] | string;
  if (typeof inner === 'string') {
    return inner;
  }
  if (inner.token) {
    return inner.token;
  }
  if (inner.res?.data?.accessToken) {
    return inner.res.data.accessToken;
  }
  return null;
}

/** Normalize API JSON so tokenData.token.token is always usable. */
export function normalizeSetupAssetStoragePayload(data: unknown): TokenData {
  const raw = data as TokenData & { storageBucket?: string };
  const accessToken = getAssetStorageAccessToken(raw);
  if (!accessToken) {
    return raw;
  }
  const existing = raw.token;
  if (existing && typeof existing === 'object' && typeof existing.token === 'string') {
    return raw;
  }
  return {
    ...raw,
    token: {
      token: accessToken,
      res: existing && typeof existing === 'object' ? existing.res : undefined,
    },
  } as TokenData;
}
